import React, { lazy, useEffect, useState, Suspense } from "react";
import { graphql, useStaticQuery } from "gatsby";
import { onetrustShowSettings, retrieveOneTrust } from "../utility/onetrust";

const CHECK_LOCATOR_COOKIE = process.env.GATSBY_CHECK_LOCATOR_COOKIE;
const LazyStoreLocation = lazy(() => import("./store-location"));
const GROUPS = ["C0003"];
const areCookiesEnabled = () =>
  window.OnetrustActiveGroups && GROUPS.some((item) => window.OnetrustActiveGroups.includes(item));

const StoreLocationWrapper = ({ data, ...other }) => {
  const [showStoreLocation, setShowStoreLocation] = useState(
    CHECK_LOCATOR_COOKIE === "true" ? undefined : true
  );
  const { labelManagerLabels } = useStaticQuery(graphql`
    {
      labelManagerLabels: labelManagerLabels {
        storeLocatorMapForCookie
        customize
      }
    }
  `);
  useEffect(() => {
    if (CHECK_LOCATOR_COOKIE === "true") {
      let goOn = true;
      const setup = async () => {
        const oneTrust = await retrieveOneTrust();
        if (goOn) {
          if (oneTrust) {
            setShowStoreLocation(areCookiesEnabled());
            oneTrust.OnConsentChanged(() => {
              setShowStoreLocation(areCookiesEnabled());
            });
          } else {
            setShowStoreLocation(true);
          }
        }
      };
      setup();
      return () => {
        goOn = false;
      };
    } else {
      setShowStoreLocation(true);
    }
  }, []);
  return showStoreLocation === undefined ? null : showStoreLocation ? (
    <Suspense>
      <LazyStoreLocation data={data} {...other} />
    </Suspense>
  ) : (
    <div className="text-center py-3">
      <p>{labelManagerLabels.storeLocatorMapForCookie}</p>
      <div>
        <button className="btn-link mt-2" onClick={onetrustShowSettings}>
          {labelManagerLabels.customize}
        </button>
      </div>
    </div>
  );
};

export default StoreLocationWrapper;
